// extracted by mini-css-extract-plugin
export var csatScore = "_mv-5";
export var header = "_mv-1";
export var panelWrapper = "_mv-2";
export var postPreview = "_mv-3";
export var rightContent = "_mv-0";
export var wrappingText = "_mv-4";